"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckClearRoom_OnEventScript = void 0;
const Registries_1 = require("../../core/state/Registries");
const enums_1 = require("../../core/enums");
const core_1 = require("../../core/actions/core");
const Enum_1 = require("../../utils/Enum");
let CheckClearRoom_OnEventScript = class CheckClearRoom_OnEventScript {
    run(sequence, container, handler, event) {
        const room = container.rooms[container.currentRoom];
        const activeFactions = container.getActors().filter(actor => !container.isDeceased(actor.id))
            .filter(actor => actor.faction === enums_1.Faction.Ally || room.actors.includes(actor.id))
            .reduce((factions, next) => {
            factions.add((0, Enum_1.enumKey)(enums_1.Faction, next.faction));
            return factions;
        }, new Set());
        if (!activeFactions.has("Enemy")) {
            container.dispatch(sequence, 0, new core_1.ClearRoomActionArgs(container.currentRoom));
        }
        else if (!activeFactions.has("Ally")) {
            container.dispatch(sequence, 0, new core_1.FailRoomActionArgs(container.currentRoom));
        }
    }
};
CheckClearRoom_OnEventScript = __decorate([
    Registries_1.EventHandlerScripts.register("CheckClearRoom_OnEvent")
], CheckClearRoom_OnEventScript);
exports.CheckClearRoom_OnEventScript = CheckClearRoom_OnEventScript;
